import { eventBus } from "@/eventBus";
import { store } from "@/store/store";

export const makeQueryString = dataObj => {
  let queryStr = "?";
  dataObj.forEach(data => {
    queryStr += `${data.key}=${data.value}&`;
  });
  queryStr = queryStr.substring(0, queryStr.length - 1);
  return queryStr;
};
export const makeQueryStringDync = dataObj => {
  if (!Object.keys(dataObj).length) return false;

  let queryStr = "?";
  for (let item in dataObj) {
    queryStr += `${item}=${dataObj[item]}&`;
  }
  queryStr = queryStr.substring(0, queryStr.length - 1);
  return queryStr;
};
export const errorServeiceHandler = response => {
  if ((response.status == 200 || response.status == 201) && response.ok) {
    return response;
  } else {
    if (response.status == 401 && store.getters.getMode != "development") {
      localStorage.removeItem("newNXTSelfcareUser");
      eventBus.$emit("snackBarMessage-app", "Valid session doesn't exist.  Please login again.");
      // return;
    }
    // else {

      throw response;
    // }
  }
};
export const makeQueryFormDataDyn = dataObj => {
  if (!Object.keys(dataObj).length) return false;
  let obj = new FormData();
  for (let data in dataObj) {
    obj.append(data, dataObj[data]);
  }
  return obj;
};



// WEBPACK FOOTER //
// ./src/store/helper.js